import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { departmentDashboard } from '../../actions/constant';
import departmentDashboardService from '../../../services/departmentDashboard/getDepartmentDashboardCount';
const {
  GET_SUPERVISOR_ALERT_REQUEST,
  GET_SUPERVISOR_ALERT_SUCCESS,
  GET_SUPERVISOR_ALERT_FAILURE,
  GET_SUPERVISOR_ALERT_LOADING,
  GET_SUPERVISOR_ALERT_RESET,
} = departmentDashboard;

function* getSupervisorAlert(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_SUPERVISOR_ALERT_LOADING });
    const response = yield call(departmentDashboardService.getSupervisorAlert, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_SUPERVISOR_ALERT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_SUPERVISOR_ALERT_FAILURE, payload: error });
  }
}

function* getSupervisorAlertSaga() {
  yield takeEvery(GET_SUPERVISOR_ALERT_REQUEST, getSupervisorAlert);
}

export default getSupervisorAlertSaga;
